function addEvent(el, type, handler) {
  if (el.attachEvent) el.attachEvent("on" + type, handler)
  else el.addEventListener(type, handler)
}

function offset(el) {
  var rect = el.getBoundingClientRect(),
    scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    scrollTop = window.pageYOffset || document.documentElement.scrollTop
  return { top: rect.top + scrollTop, left: rect.left + scrollLeft }
}

function getImageHTML(imageDataURI) {
  var newDiv = document.createElement("div")
  newDiv.className = "image-div"
  newDiv.innerHTML =
    '<img src="' + imageDataURI + '"><div class="image-details"></div>'
  return newDiv
}

function colorArrayToHex(array) {
  return array.reduce(function (hexSoFar, num) {
    return hexSoFar + (num < 16 ? "0" + num.toString(16) : num.toString(16))
  }, "#")
}

function getBrightness(color) {
  return (color[0] * 299 + color[1] * 587 + color[2] * 114) / 1000
}

export { addEvent, offset, getImageHTML, colorArrayToHex, getBrightness }
